const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const GTM_CONTAINER = "GTM-K58LZH3B";

export const trackEvent = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) { /* analytics must never break the site */ }
  try {
    if (window.location.pathname.startsWith("/admin")) return;
    const payload = JSON.stringify({
      event,
      page: window.location.pathname,
      label: params.event_label || params.item_name || params.promotion_name || params.page_path || "",
    });
    const blob = new Blob([payload], { type: "application/json" });
    if (!navigator.sendBeacon || !navigator.sendBeacon(`${API}/track/event`, blob)) {
      fetch(`${API}/track/event`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: payload, keepalive: true,
      }).catch(() => {});
    }
  } catch (e) { /* mirror is best-effort only */ }
};

export const trackPageView = (path) =>
  trackEvent("page_view", {
    page_path: path,
    page_title: document.title,
    page_location: window.location.href,
  });

const getCookie = (name) => {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : undefined;
  } catch (e) { return undefined; }
};

export const metaTrack = (eventName, eventId) => {
  try {
    fetch(`${API}/meta/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_name: eventName,
        event_id: eventId,
        event_source_url: window.location.href,
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc"),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) { /* server-side mirror is best-effort */ }
};
